import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Column } from 'primereact/column'
import { Dropdown } from 'primereact/dropdown'
import { InputText } from 'primereact/inputtext'
import { DefaultFormToolBar } from '../../../components/toolbar/DefaultFormToolBar'
import { Page } from '../../../components/page/Page'
import { icons, routes } from '../../../constants'
import { RemessaTypeUtils } from '../../../constants/remessaTypes'
import utils from '../../../utils/index'
import { actions } from '../consultaRemessa.actions'
import { ConsultaRemessaForm } from './ConsultaRemessaForm'
import { ConfirmDialog } from '../../../components/confirmDialog/ConfirmDialog'
import _ from 'lodash'
import '../../../index.scss'
import { logarAcesso } from '../../../services/api-log-acesso'
import {
  STATUS_ITEM,
  exibeReprocessarTodos,
  itensComErroSelecionados,
  labelConsultaRemessa,
  opcaoFiltroStatus,
  paramsPaginaItens,
  podeCancelarPendentes,
  podeReprocessarSelecionados,
  podeReprocessarTodos,
  semOpcaoVazia,
  textoConfirmacaoReprocessarTodos,
  textoStatusItem,
} from '../consultaRemessa.utils'

/** Espera de digitacao nos filtros de texto da grade antes de pedir a pagina ao back. */
const ESPERA_FILTRO_MS = 400

const PAGINA_INICIAL = { first: 0, rows: 15, sortField: null, sortOrder: null }
const FILTROS_INICIAIS = { status: '', oidLancamentoFinanceiro: '', mensagem: '' }

const mapStateToProps = (state) => {
  const record = state.crudConsultaRemessaState.currentRecord
  return {
    colunasItens: state.crudConsultaRemessaState.colunasItens,
    colunasLogs: state.crudConsultaRemessaState.colunasLogs,
    messages: state.crudConsultaRemessaState.messages,
    record,
    booleanTypesStatus: semOpcaoVazia([
      { label: 'TODOS', value: '' },
      { label: 'SUCESSO', value: STATUS_ITEM.SUCESSO },
      { label: 'ERRO', value: STATUS_ITEM.ERRO },
      {
        label: opcaoFiltroStatus(
          textoStatusItem(state.crudConsultaRemessaState.messages, STATUS_ITEM.AGUARDANDO_EMISSAO)
        ),
        value: STATUS_ITEM.AGUARDANDO_EMISSAO,
      },
    ]),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    loadById: (oid) => dispatch(actions.loadById(oid)),
    unmount: () => dispatch(actions.unmount()),
    sincronizarRemessa: (oidRemessa) => {
      dispatch(actions.sincronizarRemessa(oidRemessa))
    },
    downloadArquivo: (oidRemessa) => {
      dispatch(actions.downloadArquivo(oidRemessa))
    },
    loadItens: (oidRemessa, params) => dispatch(actions.loadItens(oidRemessa, params)),
    mostrarErro: (texto) => dispatch(actions.mostrarErro(texto)),
    reprocessar: (itens, oidRemessa) => dispatch(actions.reprocessar(itens, oidRemessa)),
    cancelarPendentes: (oidRemessa) => dispatch(actions.cancelarPendentes(oidRemessa)),
  }
}

/**
 * PHOENIX-977: os itens nao vem mais no formulario (uma remessa assincrona chega a 500 mil). A grade
 * pagina no servidor: pagina, ordenacao e filtros vao para POST /{oid}/itens, e o "Total" e o do back.
 * O resumo (status, contagens por status, mensagens) vem no proprio formulario.
 */
class ConsultaRemessaFormPageContainer extends React.Component {
  customButtonsOnMainToolbar = true

  constructor(props) {
    super(props)
    this.dataTableItens = React.createRef()
    this.dataTableLogs = React.createRef()
    this.timerFiltro = null
    // descarta resposta de pagina que chegou depois de outra mais nova (filtro digitado rapido)
    this.pedidoItens = 0
    this.state = {
      selectedItens: [],
      activeIndex: 0,
      pagina: PAGINA_INICIAL,
      filtros: FILTROS_INICIAIS,
      itens: [],
      totalItens: 0,
      carregandoItens: false,
      // 'selecionados' | 'todos' | 'cancelar' | null
      confirmacao: null,
      executando: false,
    }
  }

  componentDidMount() {
    const oidEntity = _.get(this, 'props.match.params.id', null)
    logarAcesso(oidEntity).then()
    if (oidEntity && parseInt(oidEntity)) {
      this.props.loadById(oidEntity)
    }
  }

  componentDidUpdate(prevProps) {
    // remessa (re)carregada - abertura, "Atualizar", depois de reprocessar/cancelar: refaz a pagina atual
    const oid = _.get(this.props, 'record.oid')
    if (oid && prevProps.record !== this.props.record) {
      this.carregarItens(this.state.pagina, this.state.filtros)
    }
  }

  componentWillUnmount() {
    this.cancelarFiltroPendente()
    this.pedidoItens++
    this.props.unmount()
  }

  carregarItens = (pagina, filtros) => {
    const oid = _.get(this.props, 'record.oid')
    if (!oid) {
      return
    }
    const pedido = ++this.pedidoItens
    this.setState({ carregandoItens: true })
    Promise.resolve(this.props.loadItens(oid, paramsPaginaItens(pagina, filtros))).then((resultado) => {
      if (pedido !== this.pedidoItens) {
        return
      }
      if (resultado && resultado.erro) {
        this.props.mostrarErro(resultado.erro)
      }
      this.setState({
        itens: (resultado && resultado.itens) || [],
        totalItens: (resultado && resultado.total) || 0,
        carregandoItens: false,
      })
    })
  }

  recarregarRemessa = () => {
    this.setState({ selectedItens: [] })
    this.props.loadById(this.props.record.oid)
  }

  hideBotaoRemover = () => {
    return true
  }

  searchHandler = () => {
    this.props.history.push(`${routes.PATH_CONSULTA_REMESSA}`)
  }

  onSelectionChange = (e) => {
    this.setState({ selectedItens: e.value })
  }

  /** Pedido de pagina/ordem anula o filtro de texto que ainda esperava a digitacao (ele usaria first 0). */
  cancelarFiltroPendente = () => {
    if (this.timerFiltro) {
      window.clearTimeout(this.timerFiltro)
      this.timerFiltro = null
    }
  }

  onPage = (e) => {
    this.cancelarFiltroPendente()
    const pagina = { ...this.state.pagina, first: e.first, rows: e.rows }
    this.setState({ pagina })
    this.carregarItens(pagina, this.state.filtros)
  }

  onSort = (e) => {
    this.cancelarFiltroPendente()
    const pagina = { ...this.state.pagina, first: 0, sortField: e.sortField, sortOrder: e.sortOrder }
    this.setState({ pagina })
    this.carregarItens(pagina, this.state.filtros)
  }

  /** Filtro mudou: volta para a primeira pagina. Texto espera a digitacao; o status vai na hora. */
  alterarFiltro = (campo, valor, imediato) => {
    const filtros = { ...this.state.filtros, [campo]: valor }
    const pagina = { ...this.state.pagina, first: 0 }
    // a selecao e do resultado filtrado: com outro filtro, linhas marcadas sumiriam da vista e iriam no reprocesso
    this.setState({ filtros, pagina, selectedItens: [] })
    this.cancelarFiltroPendente()
    if (imediato) {
      this.carregarItens(pagina, filtros)
      return
    }
    this.timerFiltro = window.setTimeout(() => {
      this.timerFiltro = null
      this.carregarItens(pagina, filtros)
    }, ESPERA_FILTRO_MS)
  }

  sincronzarRemessa = () => {
    this.props.sincronizarRemessa(this.props.record.oid)
  }

  downloadArquivo = () => {
    this.props.downloadArquivo(this.props.record.oid)
  }

  /** Executa a operacao confirmada e, dando certo, recarrega a remessa (resumo e grade). */
  confirmar = () => {
    const oid = this.props.record.oid
    const confirmacao = this.state.confirmacao
    let operacao = null
    if (confirmacao === 'selecionados') {
      operacao = this.props.reprocessar(itensComErroSelecionados(this.state.selectedItens), oid)
    } else if (confirmacao === 'todos') {
      operacao = this.props.reprocessar([], oid)
    } else if (confirmacao === 'cancelar') {
      operacao = this.props.cancelarPendentes(oid)
    }
    this.setState({ confirmacao: null, executando: true })
    Promise.resolve(operacao).then((deuCerto) => {
      this.setState({ executando: false })
      if (deuCerto) {
        this.recarregarRemessa()
      }
    })
  }

  hideDialog = () => {
    this.setState({ confirmacao: null })
  }

  label = (chave, ...parametros) => labelConsultaRemessa(this.props.messages, chave, ...parametros)

  getBotoesPersonalizados = () => {
    const botoes = []
    const record = this.props.record
    const tipo = _.get(this, 'props.record.tipo', -1)
    const comErroSelecionados = itensComErroSelecionados(this.state.selectedItens).length

    // Verifica se o tipo suporta sincronização
    if (RemessaTypeUtils.supportsSynchronization(tipo)) {
      botoes.push({
        type: 'button',
        label: 'Sincronizar',
        onClick: this.sincronzarRemessa,
      })
    }

    // Verifica se o tipo suporta download
    if (RemessaTypeUtils.supportsDownload(tipo)) {
      botoes.push({
        type: 'button',
        label: utils.getMessage(this.props.messages, 'remessa.label.download'),
        onClick: this.downloadArquivo,
        icon: icons.DOWNLOAD,
      })
    }

    if (RemessaTypeUtils.supportsReprocessing(tipo)) {
      botoes.push({
        type: 'button',
        label: `${this.label('reprocessar')} ${comErroSelecionados} ${this.label('lancamentos')}`,
        onClick: () => this.setState({ confirmacao: 'selecionados' }),
        disabled: this.state.executando || !podeReprocessarSelecionados(record, this.state.selectedItens),
      })
      // so na assincrona; a sincrona (CNAB 400 incluido) fica como antes: so o botao por selecao
      if (exibeReprocessarTodos(record)) {
        botoes.push({
          type: 'button',
          label: this.label('reprocessarTodos'),
          onClick: () => this.setState({ confirmacao: 'todos' }),
          disabled: this.state.executando || !podeReprocessarTodos(record),
        })
      }
    }

    if (podeCancelarPendentes(record)) {
      botoes.push({
        type: 'button',
        label: this.label('cancelarPendentes'),
        onClick: () => this.setState({ confirmacao: 'cancelar' }),
        disabled: this.state.executando,
        className: 'p-button-danger',
      })
    }

    if (record && record.assincrona) {
      botoes.push({
        type: 'button',
        label: this.label('atualizar'),
        onClick: this.recarregarRemessa,
        disabled: this.state.executando,
      })
    }

    return botoes
  }

  buildHeader = () => {
    return <DefaultFormToolBar formPageContainer={this} />
  }

  booleanFieldsTemplate = (rowData, column) => {
    let status = rowData[column.field]
    /**
     * 1 = SUCESSO
     * 2 = ERRO
     * 3 = PENDENTE
     * 4 = AGUARDANDO PAGAMENTO
     * 6 = APROVADA
     * 7 = CANCELADA
     * 24 = EM CONTESTACAO
     * 87 = EM MONITORAMENTO
     * 89 = REPROVADA
     * 500 = AGUARDANDO EMISSAO (PHOENIX-977: lancamento criado, boleto na fila de geracao)
     */
    let color = 'grey'
    if (status === 1 || status === 6) {
      color = 'green'
    }
    if (status === 2 || status === 7 || status === 89) {
      color = 'red'
    }
    return (
      <div style={{ color: `${color}`, display: 'flex', justifyContent: 'center' }}>
        <span className="pi pi-circle-fill" style={{ fontSize: '1.5rem' }} />
      </div>
    )
  }

  booleanFilterStatus = (column) => {
    return (
      <Dropdown
        style={{ width: '100%' }}
        name={column.field}
        className="ui-column-filter"
        value={this.state.filtros.status}
        options={this.props.booleanTypesStatus}
        onChange={(e) => this.alterarFiltro('status', e.value, true)}
        optionLabel="label"
        optionValue="value"
      />
    )
  }

  textFilter = (campo) => {
    return (
      <InputText
        style={{ width: '100%' }}
        name={campo}
        value={this.state.filtros[campo]}
        onChange={(e) => this.alterarFiltro(campo, e.target.value, false)}
      />
    )
  }

  getDialogConfirmacao = () => {
    const confirmacao = this.state.confirmacao
    if (!confirmacao) {
      return null
    }
    let conteudo = ''
    if (confirmacao === 'selecionados') {
      conteudo = this.label(
        'confirmaReprocessarSelecionados',
        itensComErroSelecionados(this.state.selectedItens).length
      )
    } else if (confirmacao === 'todos') {
      conteudo = textoConfirmacaoReprocessarTodos(this.props.messages, this.props.record)
    } else if (confirmacao === 'cancelar') {
      conteudo = this.label('confirmaCancelarPendentes')
    }
    return <ConfirmDialog visible={true} content={conteudo} confirm={this.confirmar} hideDialog={this.hideDialog} />
  }

  changeActiveIndex = (index) => {
    this.setState({ activeIndex: index })
  }

  formatColumn = (rowData, column) => {
    return utils.format(rowData, column)
  }

  // item sem lancamento (erro da geracao, remessa de erro do sincrono): celula vazia - o link iria para ".../null"
  lancamentoTemplate = (rowData) =>
    rowData.oidLancamentoFinanceiro === undefined || rowData.oidLancamentoFinanceiro === null ? null : (
      <Link to={`${routes.PATH_LANCAMENTO_FINANCEIRO}/${rowData.oidLancamentoFinanceiro}`}>
        {rowData.oidLancamentoFinanceiro}
      </Link>
    )

  render() {
    const colunasItens = this.props.colunasItens
      .filter((col) => col.visible)
      .map((col) => {
        col.showFilterMenuOptions = false
        col.showClearButton = false
        col.showFilterMenu = false

        if (col.field === 'multiselect') {
          return <Column key="multiselect" selectionMode="multiple" style={{ width: '1em' }} />
        }
        if (col.field === 'oidLancamentoFinanceiro') {
          return (
            <Column
              {...col}
              key={col.field}
              body={this.lancamentoTemplate}
              filter={true}
              filterElement={this.textFilter('oidLancamentoFinanceiro')}
              sortField={col.columnSortField}
              style={{ width: '5em', textAlign: 'center' }}
            />
          )
        } else if (col.field === 'status') {
          return (
            <Column
              {...col}
              filterHeaderStyle={{ overflow: 'visible' }}
              key={col.field}
              body={this.booleanFieldsTemplate}
              filter={true}
              field={'status'}
              sortField={col.columnSortField}
              style={{ width: '5em', textAlign: 'center' }}
              filterElement={this.booleanFilterStatus(col)}
            />
          )
        }
        return (
          <Column
            {...col}
            key={col.field}
            sortField={col.columnSortField}
            filter={true}
            filterElement={this.textFilter(col.field)}
            style={{ width: '70%', textAlign: 'left' }}
          />
        )
      })

    const colunasLogs = this.props.colunasLogs
      .filter((col) => col.visible)
      .map((col) => {
        col.showFilterMenuOptions = false
        col.showClearButton = false
        col.showFilterMenu = false
        if (col.field === 'descricao') {
          return <Column {...col} key={col.field} filter={true} sortField={col.columnSortField} />
        }
        if (col.field === 'dataGravacao') {
          return (
            <Column
              {...col}
              key={col.field}
              body={this.formatColumn}
              sortField={col.columnSortField}
              bodyClassName="column-date-body-width"
              filterHeaderClassName="column-date-filter-header-width"
              headerClassName="column-date-header-width"
            />
          )
        }
        if (col.field === 'usuarioGravacao') {
          return (
            <Column
              {...col}
              key={col.field}
              filter={true}
              sortField={col.columnSortField}
              bodyClassName="column-date-body-width"
              filterHeaderClassName="column-date-filter-header-width"
              headerClassName="column-date-header-width"
            />
          )
        }
        return null
      })

    const content = (
      <div>
        {this.getDialogConfirmacao()}
        <ConsultaRemessaForm
          selection={this.state.selectedItens}
          onSelectionChange={this.onSelectionChange}
          record={this.props.record}
          itens={this.state.itens}
          totalItens={this.state.totalItens}
          carregandoItens={this.state.carregandoItens}
          pagina={this.state.pagina}
          onPage={this.onPage}
          onSort={this.onSort}
          colunasItens={colunasItens}
          colunasLogs={colunasLogs}
          dataTableItens={(el) => (this.dataTableItens = el)}
          dataTableLogs={(el) => (this.dataTableLogs = el)}
          messages={this.props.messages}
          state={this.state}
          changeActiveIndex={this.changeActiveIndex}
        />
      </div>
    )

    return <Page header={this.buildHeader()} content={content} />
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ConsultaRemessaFormPageContainer)
